import { frontendURL } from '../../../helper/URLHelper';
import KisiPolitikasi from './KisiPolitikasi.vue';

// Gorunurluk kurali yanlis ayarlanirsa tum ekip kisileri kaybeder;
// bu yuzden yalnizca yoneticiye acik.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/settings/kisi-gorunurlugu'),
    name: 'kisi_politikasi_index',
    component: KisiPolitikasi,
    meta: { permissions: ['administrator'] },
  },
];
